<template>
  <div>
    <el-row>

      <el-col :span="24">
        <SSRTable ref="list-configs"
          :data-url="urlGetConfigurations" :schema="schema.configurations"
          data-key="configurations"
          :search-on="['shop_id', 'shop_name']">
          <div slot="is_mobile_payment" slot-scope="{row}">
            <i class="el-icon-circle-check" style="color: green" v-if="row.is_mobile_payment"></i>
          </div>
          <div slot="methods" slot-scope="{row}">
            <!-- <span v-for="m in row.methods">{{ m }}&nbsp;</span> -->
            <div class="d-flex">
              <div v-for="m in row.methods" :key="m">
                <img :src="getPaymentMethodLogoSrc(m)" class="ico-payment-method" :class="{
                  'ico-payment-method-applepay': m === 'applepay',
                  'ico-payment-method-googlepay': m === 'googlepay',
                  'ico-payment-method-linepay': m === 'linepay',
                  'ico-payment-method-jkopay': m === 'jkopay',
                  'ico-payment-method-easywallet': m === 'easywallet',
                  'ico-payment-method-taiwanpay': m === 'taiwanpay',
                  'ico-payment-method-icashpay': m === 'icashpay',
                  'ico-payment-method-pxpay': m === 'pxpay' || m ==='pxpayplus',
                  'ico-payment-method-pluspay': m === 'pluspay',
                  'ico-payment-method-twqr': m === 'twqr' || m ==='yuanta',
                  'ico-payment-method-aftee': m === 'aftee' || m ==='aftee',
                }">
              </div>
            </div>
          </div>
          <div slot="actions" slot-scope="{row}">
            <el-button round size="mini" icon="el-icon-refresh"
              :disabled="row.is_mobile_payment == 0"
              @click="syncPaymentConfig(row.shop_id)">
              更新支付選項
            </el-button>
          </div>
        </SSRTable>
      </el-col>
    </el-row>
  </div>  
</template>

<script>
import SSRTable from 'src/components/SSRTable';

import axios from 'axios';
import moment from 'moment';

export default {
  components: {
    SSRTable
  },

  mounted() {

  },

  methods: {
    syncPaymentConfig(shopId) {
      axios.get(`${process.env.VUE_APP_APIHOST}/${this.userType}/online-payment-configs/${shopId}?doSync=true`)
      .then(response => {
        this.$refs['list-configs'].loadData();
        this.$notify.success({
          title: '同步完成！'
        });
      })
      .catch(err => {
        console.error(`[ONLINE-PAYMENT-CONFIGS] GET and sync failed`, err);
        this.$notify.error({
          title: '錯誤 - 暫時無法同步支付列表',
          message: err.data.message
        });
      });
    },

    getPaymentMethodLogoSrc(method) {
      let subfileName = [ 'taiwanpay', 'pxpay', 'pxpayplus', 'pluspay', 'twqr', 'yuanta', 'aftee' ].indexOf(method) >= 0 ? 'png': 'svg';
      return `${process.env.BASE_URL}img/payment-services/${method}.${subfileName}`;
    }
  },

  data() {
    return {
      search: '',

      schema: {
        configurations: [
          { key: 'shop_id', label: '#' },
          { key: 'shop_name', label: '店家' },
          { key: 'is_mobile_payment', label: '已啟用線上支付？', align: 'center' },
          { key: 'methods', label: '線上支付選項', width: 600 },
          { key: 'actions', label: '' }
        ]
      }
    };
  },

  computed: {
    userType() {
      return this.$store.getters.userType;
    },

    urlGetConfigurations() {
      return `${process.env.VUE_APP_APIHOST}/${this.userType}/online-payment-configs`
        + (this.search.length? `?search=${this.search}`: '');
    }
  }
}
</script>

<style scoped>
img.ico-payment-method {
  margin: 2px;
  width: 72px;
  height: 40px;
  border: 1px solid #bbbbbb;
  border-radius: 4px;
}
img.ico-payment-method-applepay,
img.ico-payment-method-googlepay {
  padding: 8px 8px;
  width: 84px;
}
img.ico-payment-method-linepay,
img.ico-payment-method-easywallet {
  padding: 2px 6px;
  width: 96px;
}
img.ico-payment-method-taiwanpay {
  padding: 6px 6px;
  width: 108px;
}
img.ico-payment-method-pluspay,
img.ico-payment-method-pxpay,
img.ico-payment-method-pxpayplus,
img.ico-payment-method-icashpay
 {
  padding: 6px 6px;
  width: 108px;
}
img.ico-payment-method-twqr
 {
  padding: 6px 6px;
  width: 108px;
}
img.ico-payment-method-aftee {
  padding: 6px 6px;
  width: 108px;
}

</style>